import React from "react";
import { useLocalization } from "utilities/hooks/use-localization";

const cssBaseClass = "c-chat-length-limited-tooltip-content";

const ChatLengthLimitedTooltipContent: React.FC = () => {
    const { t } = useLocalization();

    return (
        <>
            <div className={`${cssBaseClass}__title`}>
                {t("chat-length-limit-title")}
            </div>
            <div className={`${cssBaseClass}__description`}>
                {t("chat-length-limit-description")}
            </div>
        </>
    );
};

export default ChatLengthLimitedTooltipContent;
